<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento') }}:
                |
                | {{ restricao.dpto_desc || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.distrito') }}:
                |
                | {{ restricao.dist_desc_ || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                |
                | {{ restricao.ano || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao.nombre || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.categoria') }}:
                |
                | {{ restricao.categoria_ || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.subsistema') }}:
                |
                | {{ restricao.subsistema || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.lei') }}:
                |
                | {{ restricao.ley || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.decreto') }}:
                |
                | {{ restricao.decreto || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.criticidadeDaRestricao') }}:
                |
                | {{ restricao.nivelAlerta }}
                i.m-2.el-icon-remove-outline.custon-icon-el(
                    v-if='(restricao.status && restricao.status === "ERROR")'
                )
                i.m-2.flow.flow-verified.verde.mr8.custon-icon(
                    v-else-if='(restricao.nivelAlerta && restricao.nivelAlerta === "BAIXO")'
                )
                i.m-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
                    v-else-if='(restricao.nivelAlerta && restricao.nivelAlerta === "MEDIO")'
                )
                i.m-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                    v-else='(restricao.nivelAlerta && restricao.nivelAlerta === "ALTO") || (!restricao.nivelAlerta)'
                )
                el-tooltip(placement='right', effect='light')
                    div(slot="content", style="max-width: 400px;text-align: justify;") {{ $t('mensagens.diagnosticoSocioambiental.infoAreasProtegidasParaguai') }}
                    i.mdi.mdi-information-outline
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'soja-2022-areas-protegidas-paraguai',

    data() {
        return {};
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    }
};
</script>
<style lang="scss" scoped>
.mdi:before {
    font-size: 18px !important;
    color: var(--gray);
}
</style>
